<template>
  <div class="px-8 py-6" style="height:100%; width:100%;">
    <h3>발주입고현황</h3>
    <h4 class="my-5">
      발주입고 현황 상세정보
    </h4>
    <div class="pt-3 pb-5 ma-0 d-flex">
      <div class="pr-5">
        <span class="span-setting1 justify-center align-center d-flex">
          <h5>{{ "현장명 : " + orderInvoiceList.constructionName }}</h5>
        </span>
      </div>
      <div class="pr-5">
        <span class="span-setting1 justify-center align-center d-flex">
          <h5>{{ "차수 : " + orderInvoiceList.orderName }}</h5>
        </span>
      </div>
      <div class="pr-5">
        <span class="span-setting2 justify-center align-center d-flex">
          <h5>{{ `부위명 : ${orderInvoiceList.partName}` }}</h5>
        </span>
      </div>
      <div class="pr-5">
        <span class="span-setting2 justify-center align-center d-flex">
          <h5>
            {{ `동 : ${orderInvoiceList.dong ? orderInvoiceList.dong : ""}` }}
          </h5>
        </span>
      </div>
      <div class="pr-5">
        <span class="span-setting2 justify-center align-center d-flex">
          <h5>
            {{ `층 : ${orderInvoiceList.floor ? orderInvoiceList.floor : ""}` }}
          </h5>
        </span>
      </div>
      <div class="pr-5">
        <span class="span-setting2 justify-center align-center d-flex">
          <h5>
            {{ `부재 : ${orderInvoiceList.type ? orderInvoiceList.type : ""}` }}
          </h5>
        </span>
      </div>
    </div>
    <div justify-center align-center class="ma-0">
      <v-simple-table class="width-100" fixed-header height="580" dense>
        <thead>
          <tr class="back-8ca9dd">
            <th
              class="text-center back-8ca9dd color-white border-right-white"
              rowspan="2"
            >
              발주차수
            </th>
            <th
              class="text-center back-8ca9dd color-white border-right-white"
              rowspan="2"
            >
              구분
            </th>
            <th
              class="text-center back-8ca9dd color-white border-right-white"
              rowspan="1"
              :colspan="materialLength"
            >
              규격(단위:TON)
            </th>
            <th
              class="text-center back-8ca9dd color-white  border-right-white"
              rowspan="2"
            >
              합계수량
            </th>
            <th
              class="text-center back-8ca9dd color-white border-right-white"
              rowspan="2"
            >
              등록일자/입고일자
            </th>
            <th
              class="text-center back-8ca9dd color-white border-right-white"
              rowspan="2"
            >
              출고일자
            </th>
            <th class="text-center back-8ca9dd color-white" rowspan="2">
              메모
            </th>
          </tr>
          <tr>
            <th
              class="text-center back-8ca9dd color-white border-top-white border-right-white "
              v-for="list in materialList"
              :key="list.rebar_id"
            >
              {{ list.rebar_name }}
            </th>
          </tr>
        </thead>
        <tbody v-if="orderInvoiceList">
          <tr>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa border-left-aaaaaa text-center"
              colspan="2"
            >
              발주
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-right pr-1"
              v-for="(value, index) in orderInvoiceList.orderValue"
              :key="index"
            >
              {{ value ? mathRound(value).toFixed(3) : "0" }}
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-right pr-1"
            >
              {{ sum(orderInvoiceList.orderValue).toFixed(3) }}
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa text-center">
              {{ orderInvoiceList.registDate | moment("YY.MM.DD") }}
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-center"
            ></td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-center  color-0038FF"
            >
              <v-btn
                @click="memoClick(orderInvoiceList.orderId, 'order')"
                color="#0038FF"
                text
              >
                {{ orderInvoiceList.orderMemo ? "보기" : "추가" }}
              </v-btn>
            </td>
          </tr>
          <tr
            v-for="list in orderInvoiceList.invoiceinfos"
            :key="list.invoiceId"
          >
            <td
              class="border-right-aaaaaa text-center border-bottom-aaaaaa border-left-aaaaaa"
            >
              {{ orderInvoiceList.orderName }}
            </td>
            <td class="border-right-aaaaaa text-center border-bottom-aaaaaa">
              {{ list.completion == "N" ? "출고완료" : "입고완료" }}
            </td>
            <td
              class="border-right-aaaaaa text-right pr-1 border-bottom-aaaaaa"
              v-for="(value, index) in list.invoiceValue"
              :key="index"
            >
              {{ value ? mathRound(value).toFixed(3) : "0" }}
            </td>
            <td
              class="border-right-aaaaaa text-right pr-1 border-bottom-aaaaaa"
            >
              {{ sum(list.invoiceValue).toFixed(3) }}
            </td>
            <td class="border-right-aaaaaa text-center border-bottom-aaaaaa">
              {{ list.invoiceCompleteDate | moment("YY.MM.DD") }}
            </td>
            <td class="border-right-aaaaaa text-center border-bottom-aaaaaa">
              {{ list.invoiceDate | moment("YY.MM.DD") }}
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-center  color-0038FF"
            >
              <v-btn
                @click="memoClick(list.invoiceId, 'invoice')"
                color="#0038FF"
                text
              >
                {{
                  orderInvoiceList.invoiceMemo.includes(list.invoiceCode)
                    ? "보기"
                    : "추가"
                }}
              </v-btn>
            </td>
          </tr>
          <tr class="text-center" v-if="orderSumList.length > 1">
            <td colspan="2" class="border-left-aaaaaa border-right-aaaaaa">
              출고합계
            </td>
            <td
              v-for="(orderSum, index) in orderSumList"
              :key="index"
              class="border-right-aaaaaa text-right pr-1"
            >
              {{ orderSum ? mathRound(orderSum).toFixed(3) : "0" }}
            </td>
            <td class="border-right-aaaaaa text-right pr-1">
              {{ sum(orderSumList).toFixed(3) }}
            </td>
            <td colspan="3" class="border-right-aaaaaa"></td>
          </tr>
          <tr class="text-center" v-if="orderSumList.length > 1">
            <td
              colspan="2"
              class="border-left-aaaaaa border-right-aaaaaa border-bottom-aaaaaa"
            >
              잔량
            </td>
            <td
              v-for="(orderSum, index) in orderSumList"
              :key="index"
              class="border-right-aaaaaa border-bottom-aaaaaa text-right pr-1"
              :style="
                Number(orderSum - orderInvoiceList.orderValue[index]) == 0
                  ? ''
                  : Number(orderSum - orderInvoiceList.orderValue[index]) > 0
                  ? 'color:red'
                  : 'color:blue'
              "
            >
              {{
                mathRound(
                  orderSum - orderInvoiceList.orderValue[index]
                ).toFixed(3)
              }}
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-right pr-1"
              :style="
                Number(sum(orderSumList) - sum(orderInvoiceList.orderValue)) ==
                0
                  ? ''
                  : Number(
                      sum(orderSumList) - sum(orderInvoiceList.orderValue)
                    ) > 0
                  ? 'color:red'
                  : 'color:blue'
              "
            >
              {{
                mathRound(
                  sum(orderSumList) - sum(orderInvoiceList.orderValue)
                ).toFixed(3)
              }}
            </td>
            <td
              colspan="3"
              class="border-right-aaaaaa border-bottom-aaaaaa"
            ></td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import OrderInvoiceAPi from "@/api/OrderInvoiceService";
import Commonality from "@/mixin/Commonality";

export default {
  mixins: [Commonality],
  props: ["orderId"],

  async created() {
    this.$bus.$emit("loadingStart");
    if (this.orderId) {
      this.reset();
    } else {
      this.$router.go(-1);
    }
    this.$bus.$emit("loadingEnd");
  },

  data: () => ({
    orderInvoiceList: [],
    orderSumList: [],
  }),
  watch: {
    orderInvoiceList(val) {
      this.orderSumList = this.listSum(val.invoiceinfos, "invoiceValue");
    },
  },
  computed: {
    materialLength() {
      return this.materialList.length;
    },
  },
  methods: {
    async reset() {
      let data = { orderId: this.orderId };
      let returnData = await OrderInvoiceAPi.orderinvoiceDetail(data);
      this.orderInvoiceList = returnData.data.orderInvoiceList[0];
    },
  },
};
</script>

<style scoped>
.span-setting1 {
  text-align: center;
  background: #dde0e7;
  border-radius: 25px;
  min-width: 130px;
  height: 38px;
  padding-left: 5px;
  padding-right: 5px;
  vertical-align: middle;
}

.span-setting2 {
  text-align: center;
  background: #dde0e7;
  border-radius: 25px;
  min-width: 130px;
  padding-left: 5px;
  padding-right: 5px;
  height: 38px;
  vertical-align: middle;
}
</style>
